import React, { Fragment, useState, createRef } from 'react';
import { Form, Col, Row, FormGroup, Modal } from 'react-bootstrap';
import Input from '../utils/Input';
import validate from '../validateForm/valdidateContactForm';
import useForm from '../../Hooks/useForm';
// import SubmitModal from './SubmitModal';
import StyledModal from '../../styles/StyledModal';
import StyledButton from '../../styles/StyledButton';
import Alert from '@material-ui/lab/Alert';
import axiosInstance from '../utils/axios';
import ReCAPTCHA from 'react-google-recaptcha';



const ContactUsModal = ({ showModal, handleCloseModal }) => {
    const initalInputState = { name: '', email: '', subject: '', message: '', reCaptchaChecked: false }
    const [contactSubmit, setContactSubmit] = useState([]);
    const recaptchaRef = createRef();


    const onSubmit = () => {
        axiosInstance({
            method: 'post',
            url: '/contactus',
            data: {
                Fullname: name,
                Emailaddress: email,
                Subject: subject,
                Message: message
            }
        })
            .then(res => {
                setContactSubmit(res.data);
            })
            .catch(err => console.log(err))
    }

    const { handleInputChange, onChange, handleSubmit, values, errors } = useForm(onSubmit, initalInputState, validate, recaptchaRef);
    const { name, email, subject, message, reCaptchaChecked } = values;

    return (
        <Fragment>
            <StyledModal show={showModal} size='md' onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title><img className='modal-img' alt='hallmark media logo' src='/images/HallmarkMedia_Logo_Plum_RGB.png' /></Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className='contactForm-container'>
                        <Row>
                            <Col>
                                <h5>Contact Us</h5>
                                <p>We'd love to hear from you.</p>
                                {
                                    (contactSubmit === 'Request successfully submitted.') ?
                                        <Alert severity="success">Success! Your message has been sent. Please allow 1-2 business days for a reply.</Alert> :
                                        null
                                }
                                {
                                    (contactSubmit === 'There has been a problem.') ?
                                        <Alert severity="error">Error! There has been an error, your message was not sent. Please try again or contact adminstrator.</Alert> :
                                        null
                                }

                            </Col>
                        </Row>
                        <Row className='mt-3'>
                            <Col>
                                < Form >
                                    <div className="column">
                                        <FormGroup controlId='name'>
                                            <Input
                                                inputtype="input"
                                                name='name'
                                                className={`form-control ${errors.name && 'is-invalid'}`}
                                                type="text"
                                                formlabel='Full Name'
                                                placeholder="Enter your full name"
                                                value={name}
                                                onChange={handleInputChange}
                                            />
                                            {errors.name && <p className='invalid-feedback'>
                                                {errors.firstName}
                                            </p>
                                            }
                                        </FormGroup>
                                        <FormGroup controlId='email'>
                                            <Input
                                                inputtype="input"
                                                name='email'
                                                className={`form-control ${errors.email && 'is-invalid'}`}
                                                type="email"
                                                formlabel='Email Address'
                                                placeholder="Enter your email"
                                                value={email}
                                                onChange={handleInputChange}
                                            />
                                            {errors.email && <p className='invalid-feedback'>
                                                {errors.email}
                                            </p>
                                            }

                                        </FormGroup>
                                        <FormGroup controlId='subject'>
                                            <Input
                                                inputtype="input"
                                                name='subject'
                                                className={`form-control ${errors.subject && 'is-invalid'}`}
                                                type="text"
                                                formlabel='Subject'
                                                placeholder="Enter a subject"
                                                value={subject}
                                                onChange={handleInputChange}
                                            />
                                            {errors.subject && <p className='invalid-feedback'>
                                                {errors.subject}
                                            </p>
                                            }

                                        </FormGroup>
                                        <FormGroup controlId="message">
                                            <Input
                                                inputtype="textarea"
                                                name='message'
                                                className={`form-control ${errors.message && 'is-invalid'}`}
                                                type="textarea"
                                                formlabel='Message'
                                                placeholder="Enter your message"
                                                value={message}
                                                onChange={handleInputChange}
                                            />
                                            {errors.message && <p className='invalid-feedback'>
                                                {errors.message}
                                            </p>
                                            }

                                        </FormGroup>

                                        <ReCAPTCHA
                                            ref={recaptchaRef}
                                            sitekey="6Ldj_awoAAAAAGFDcZvVLqgcZXIAFEJDThQfAOdW"
                                            // hallmarkmediainternational sitekey above

                                            // sitekey="6LdoorcZAAAAAF0fJi8qFCO2AyoblNv1JOS7UjKY"
                                            // localhost testing sitekey above

                                            onChange={onChange}
                                            className={reCaptchaChecked ? null : `reCaptcha ${errors.reCaptchaChecked && 'is-invalid'}`}
                                        />
                                        {errors.reCaptchaChecked && <p className='invalid-feedback'>
                                            {errors.reCaptchaChecked}
                                        </p>
                                        }
                                        <br />

                                        <Modal.Footer>
                                            {
                                                (contactSubmit === 'Request successfully submitted.') ?
                                                    <StyledButton className='purple--btn' as='a' type='submit' onClick={handleCloseModal}>Close</StyledButton> :
                                                    <StyledButton className='purple--btn' as='a' type='submit' onClick={() => handleSubmit()}>Submit</StyledButton>
                                            }

                                        </Modal.Footer>
                                    </div>
                                </Form >

                            </Col>
                        </Row>


                    </div>
                </Modal.Body>

            </StyledModal>

        </Fragment>
    )
}

export default ContactUsModal;